import { render, staticRenderFns } from "./k-table.vue?vue&type=template&id=29a1432a&scoped=true&"
import script from "./k-table.vue?vue&type=script&lang=ts&"
export * from "./k-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a1432a",
  null
  
)

export default component.exports